import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // ページ遷移時に最上部にスクロール
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Company', path: '/company' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <motion.header
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-8 lg:px-16 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <img 
              src="https://static.readdy.ai/image/4df5c7deddaddbbeeb26e7a7cacf2afd/04612241165ac6755bde3331d7ab7803.png" 
              alt="SINAX Logo" 
              className="h-12 w-auto"
            />
            <span className={`font-serif text-3xl tracking-wider transition-colors duration-300 ${isScrolled ? 'text-darkgray' : 'text-white'}`}>SINAX</span>
          </Link>

          <nav className="hidden md:flex items-center gap-10">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative font-sans text-sm tracking-wide group transition-colors duration-300 ${isScrolled ? 'text-darkgray' : 'text-white'}`}
              >
                {item.name}
                <span
                  className={`absolute bottom-0 left-0 h-px transition-all duration-300 ${
                    isScrolled ? 'bg-darkgray' : 'bg-white'
                  } ${
                    location.pathname === item.path ? 'w-full' : 'w-0 group-hover:w-full'
                  }`}
                />
              </Link>
            ))}
          </nav>

          <Link
            to="/contact"
            className="whitespace-nowrap px-6 py-2.5 bg-mustard text-white text-sm font-sans tracking-wide rounded cursor-pointer transition-all duration-300 hover:bg-opacity-90"
          >
            お問い合わせ
          </Link>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
